import React from "react";
import Layout from "../../assets/Layout";
import UserLayout from "../../assets/UserLayout";
import { Box, Button, Grid, Paper, TextField, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import DoneIcon from "@mui/icons-material/Done";
import ClearIcon from "@mui/icons-material/Clear";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";

export default function CurrentPackage() {
  return (
    <>
      <Layout>
        <UserLayout userRole={"employer"}>
          <Grid container mt={8} px={5}>
            <Grid item md={8}>
              <Typography className="heading1bold">Packages</Typography>
            </Grid>
            <Grid item md={4}>
              <TextField
                sx={{
                  background: "#F8FAFF",
                  boxShadow:
                    "0px 23.48060417175293px 46.96120834350586px -8.80522632598877px #3665D014",
                  width: "100%",
                }}
                variant="outlined"
                size="small"
                placeholder="Search"
                InputProps={{
                  endAdornment: <SearchIcon sx={{ opacity: "0.5" }} />,
                }}
              />
            </Grid>
          </Grid>
          <Box px={5} mt={8}>
            <Typography className="heading1bold">Current Package</Typography>

            <Grid container spacing={3}>
              <Grid item md={3}>
                <Paper>
                  <Box sx={{ color: "#181059", mt: 4, p: 2 }}>
                    <Typography className="heading1bold">Intro</Typography>
                    <Box>
                      <Box sx={{ display: "flex", gap: 1, pt: 2 }}>
                        <DoneIcon />{" "}
                        <Typography className="packageCardText">
                          Upload Video up to 720p Resolution
                        </Typography>
                      </Box>
                      <Box
                        sx={{ display: "flex", gap: 1, pt: 1, opacity: 0.5 }}
                      >
                        <ClearIcon />{" "}
                        <Typography className="packageCardText">
                          Attachment & Post Scheduling
                        </Typography>
                      </Box>
                      <Box
                        sx={{ display: "flex", gap: 1, pt: 1, opacity: 0.5 }}
                      >
                        <ClearIcon />{" "}
                        <Typography className="packageCardText">
                          Set your rates
                        </Typography>
                      </Box>
                      <Box
                        sx={{ display: "flex", gap: 1, pt: 1, opacity: 0.5 }}
                      >
                        <ClearIcon />{" "}
                        <Typography className="packageCardText">
                          Exclusive Deals
                        </Typography>
                      </Box>
                      <Box
                        sx={{ display: "flex", gap: 1, pt: 1, opacity: 0.5 }}
                      >
                        <ClearIcon />{" "}
                        <Typography className="packageCardText">
                          Advanced Statistics
                        </Typography>
                      </Box>
                    </Box>
                    <Box sx={{ pt: 1 }}>
                      <Typography
                        sx={{
                          fontFamily: "Inter",
                          fontWeight: 500,
                          fontSize: "20px",
                        }}
                      >
                        ₹
                        <span style={{ fontSize: "30px", fontWeight: 700 }}>
                          123
                        </span>{" "}
                        /month{" "}
                      </Typography>
                    </Box>
                    <Box pt={2}>
                      <Button
                        variant="contained"
                        sx={{
                          width: "100%",
                          py: 1.5,
                          bgcolor: "#2544EE",
                          textTransform: "none",
                          fontFamily: "Inter",
                          fontWeight: 600,
                          fontSize: "20px",
                        }}
                      >
                        Choose
                      </Button>
                    </Box>
                  </Box>
                </Paper>
              </Grid>
              <Grid item md={3}> 
              <Paper>
                  <Box sx={{ color: "#181059", mt: 4, p: 2 }}>
                    <Typography className="heading1bold">Base</Typography>
                    <Box>
                      <Box sx={{ display: "flex", gap: 1, pt: 2 }}>
                        <DoneIcon />{" "}
                        <Typography className="packageCardText">
                          Upload Video up to 720p Resolution
                        </Typography>
                      </Box>
                      <Box
                        sx={{ display: "flex", gap: 1, pt: 1, }}
                      >
                        <DoneIcon />{" "}
                        <Typography className="packageCardText">
                          Attachment & Post Scheduling
                        </Typography>
                      </Box>
                      <Box
                        sx={{ display: "flex", gap: 1, pt: 1, opacity: 0.5 }}
                      >
                        <ClearIcon />{" "}
                        <Typography className="packageCardText">
                          Set your rates
                        </Typography>
                      </Box>
                      <Box
                        sx={{ display: "flex", gap: 1, pt: 1, opacity: 0.5 }}
                      >
                        <ClearIcon />{" "}
                        <Typography className="packageCardText">
                          Exclusive Deals
                        </Typography>
                      </Box>
                      <Box
                        sx={{ display: "flex", gap: 1, pt: 1, opacity: 0.5 }}
                      >
                        <ClearIcon />{" "}
                        <Typography className="packageCardText">
                          Advanced Statistics
                        </Typography>
                      </Box>
                    </Box>
                    <Box sx={{ pt: 1 }}>
                      <Typography
                        sx={{
                          fontFamily: "Inter",
                          fontWeight: 500,
                          fontSize: "20px",
                        }}
                      >
                        ₹
                        <span style={{ fontSize: "30px", fontWeight: 700 }}>
                          123
                        </span>{" "}
                        /month{" "}
                      </Typography>
                    </Box>
                    <Box pt={2}>
                      <Button
                        variant="contained"
                        sx={{
                          width: "100%",
                          py: 1.5,
                          bgcolor: "#2544EE",
                          textTransform: "none",
                          fontFamily: "Inter",
                          fontWeight: 600,
                          fontSize: "20px",
                        }}
                      >
                        Choose
                      </Button>
                    </Box>
                  </Box>
                </Paper></Grid>
              <Grid item md={3}> <Paper sx={{bgcolor:'#2544EE'}}>
                  <Box sx={{ color:'#fff', mt: 4, p: 2 }}>
                    <Typography className="heading1bold">Pro</Typography>
                    <Box>
                      <Box sx={{ display: "flex", gap: 1, pt: 2 }}>
                        <DoneIcon />{" "}
                        <Typography className="packageCardText">
                          Upload Video up to 720p Resolution
                        </Typography>
                      </Box>
                      <Box
                        sx={{ display: "flex", gap: 1, pt: 1,  }}
                      >
                        <DoneIcon />{" "}
                        <Typography className="packageCardText">
                          Attachment & Post Scheduling
                        </Typography>
                      </Box>
                      <Box
                        sx={{ display: "flex", gap: 1, pt: 1, }}
                      >
                        <DoneIcon />{" "}
                        <Typography className="packageCardText">
                          Set your rates
                        </Typography>
                      </Box>
                      <Box
                        sx={{ display: "flex", gap: 1, pt: 1, opacity: 0.5 }}
                      >
                        <ClearIcon />{" "}
                        <Typography className="packageCardText">
                          Exclusive Deals
                        </Typography>
                      </Box>
                      <Box
                        sx={{ display: "flex", gap: 1, pt: 1, opacity: 0.5 }}
                      >
                        <ClearIcon />{" "}
                        <Typography className="packageCardText">
                          Advanced Statistics
                        </Typography>
                      </Box>
                    </Box>
                    <Box sx={{ pt: 1 }}>
                      <Typography
                        sx={{
                          fontFamily: "Inter",
                          fontWeight: 500,
                          fontSize: "20px",
                        }}
                      >
                        ₹
                        <span style={{ fontSize: "30px", fontWeight: 700 }}>
                          123
                        </span>{" "}
                        /month{" "}
                      </Typography>
                    </Box>
                    <Box pt={2}>
                      <Button
                        variant="contained"
                        sx={{
                          width: "100%",
                          py: 1.5,
                          bgcolor: "#fff",
                          color:'#2544EE',
                          textTransform: "none",
                          fontFamily: "Inter",
                          fontWeight: 600,
                          fontSize: "20px",
                          '&:hover':{
                            color:'#fff',
                            bgcolor:'#2544EE'
                          }
                        }}
                      >
                        Renew
                      </Button>
                    </Box>
                    <Box pt={2}>
                      <Button
                        variant="outlined"
                        sx={{
                          width: "100%",
                          py: 1.5,
                          color: "#fff",
                          textTransform: "none",
                          fontFamily: "Inter",
                          fontWeight: 600,
                          fontSize: "20px",
                          border:'1px solid #fff'
                        
                        }}
                      >
                        Cancel
                      </Button>
                    </Box>
                  </Box>
                </Paper></Grid>
              <Grid item md={3}> 
              <Paper>
                  <Box  sx={{ color: "#181059", mt: 4, p: 2 }}>
                    <Typography className="heading1bold">Enterprise</Typography>
                    <Box>
                      <Box sx={{ display: "flex", gap: 1, pt: 2 }}>
                        <DoneIcon />{" "}
                        <Typography className="packageCardText">
                          Upload Video up to 720p Resolution
                        </Typography>
                      </Box>
                      <Box
                        sx={{ display: "flex", gap: 1, pt: 1,  }}
                      >
                        <DoneIcon />{" "}
                        <Typography className="packageCardText">
                          Attachment & Post Scheduling
                        </Typography>
                      </Box>
                      <Box
                        sx={{ display: "flex", gap: 1, pt: 1,  }}
                      >
                        <DoneIcon />{" "}
                        <Typography className="packageCardText">
                          Set your rates
                        </Typography>
                      </Box>
                      <Box
                        sx={{ display: "flex", gap: 1, pt: 1,  }}
                      >
                       <DoneIcon />{" "}
                        <Typography className="packageCardText">
                          Exclusive Deals
                        </Typography>
                      </Box>
                      <Box
                        sx={{ display: "flex", gap: 1, pt: 1, }}
                      >
                        <DoneIcon />{" "}
                        <Typography className="packageCardText">
                          Advanced Statistics
                        </Typography>
                      </Box>
                    </Box>
                    <Box sx={{ pt: 1 }}>
                      <Typography
                        sx={{
                          fontFamily: "Inter",
                          fontWeight: 500,
                          fontSize: "20px",
                        }}
                      >
                        ₹
                        <span style={{ fontSize: "30px", fontWeight: 700 }}>
                          123
                        </span>{" "}
                        /month{" "}
                      </Typography>
                    </Box>
                    <Box pt={2}>
                      <Button
                        variant="contained"
                        sx={{
                          width: "100%",
                          py: 1.5,
                          bgcolor: "#2544EE",
                          textTransform: "none",
                          fontFamily: "Inter",
                          fontWeight: 600,
                          fontSize: "20px",
                        }}
                      >
                        Choose
                      </Button>
                    </Box>
                  </Box>
                </Paper></Grid>
            </Grid>
          </Box>
        </UserLayout>
      </Layout>
    </>
  );
}
